import { render, staticRenderFns } from "./jobbank.vue?vue&type=template&id=28a528cc&scoped=true"
import script from "./jobbank.vue?vue&type=script&lang=js"
export * from "./jobbank.vue?vue&type=script&lang=js"
import style0 from "./jobbank.vue?vue&type=style&index=0&id=28a528cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a528cc",
  null
  
)

export default component.exports